import { Tooltip, brandIcons, Stack, Typography, theme } from '@hiver/hiver-ui-kit';
import styled from 'styled-components';
import SessionedLink from '../SessionedLink';


const PlanUpgradeTooltipStyles = {
    '&.MuiTooltip-popper':{ 
        '& .MuiTooltip-tooltip':{
            maxWidth:'302px',
        },
        '& .MuiSvgIcon-root':{        
            padding: theme.spacing(0.5),
            borderRadius: '21px',
            background: theme.palette.gray.gray1,
        },
        '& .MuiTypography-root':{
            margin: 0
        }
    }
}

const LinkWrapper = styled.span`
    font-weight: 600;
    color: #fff;
    &:hover {
        text-decoration-line: underline;
    }
`;

const defaultTooltipText = (upgradeClickedEvent) => (
    <span>
      This is not available on your current plan.{' '}
      <SessionedLink to="/app/settings/account/upgrade" gainsightEvent={upgradeClickedEvent} >
        <LinkWrapper>Upgrade now</LinkWrapper>
      </SessionedLink>
      {' '}to access this feature.
    </span>
  );

export const PlanUpgradeTooltip = ({ text, children, upgradeClickedEvent, displaytooltip = false }) => {
    const tooltipText = text ?? defaultTooltipText(upgradeClickedEvent);
    return (
    <Tooltip arrow placement="bottom"
        PopperProps={{ sx: PlanUpgradeTooltipStyles }}
        title={
            displaytooltip ? (
                <Stack spacing={1} direction="row" alignItems="center" gap={theme.spacing(1.25)}>
                    <brandIcons.Crown sx={{ height: '20px', width: '20px' }} />
                    <Typography variant="caption">{tooltipText}</Typography>
                </Stack>
            ) : null
        }>
        <div>
            {children}
        </div>
    </Tooltip>
    );
}
